/* ==========================================================
   EFFORTLESS HERO
   Device-exclusive media controller
   ========================================================== */

(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  function initHero(hero) {
    if (!hero || hero.dataset.deviceMediaReady === 'true') return;
    hero.dataset.deviceMediaReady = 'true';

    const updateDeviceMedia = () => {
      const isMobile = window.matchMedia(MOBILE_QUERY).matches;
      const activeDevice = isMobile ? 'mobile' : 'desktop';
      const media = hero.querySelectorAll('[data-hero-device]');

      media.forEach((item) => {
        const active = item.dataset.heroDevice === activeDevice;
        item.classList.toggle('is-device-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      hero.querySelectorAll('video').forEach((video) => {
        const owner = video.closest('[data-hero-device]');
        const active = owner && owner.classList.contains('is-device-active');

        if (!active) {
          video.pause();
          return;
        }

        // Keep autoplay fully silent and inline so mobile browsers do not
        // require a user tap and do not show a native play control.
        video.autoplay = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('preload', 'auto');
        video.removeAttribute('controls');

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Autoplay can still be blocked by an individual browser policy.
            // There is intentionally no visible play button added by this theme.
          });
        }
      });
    };

    hero.classList.add('is-loaded');
    updateDeviceMedia();

    // Retry muted autoplay as soon as the active video is ready.
    hero.querySelectorAll('video').forEach((video) => {
      const tryAutoplay = () => {
        const owner = video.closest('[data-hero-device]');
        if (!owner || !owner.classList.contains('is-device-active')) return;
        video.muted = true;
        video.defaultMuted = true;
        video.play().catch(() => {});
      };
      video.addEventListener('loadedmetadata', tryAutoplay, { once: false });
      video.addEventListener('canplay', tryAutoplay, { once: false });
    });

    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateDeviceMedia);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(updateDeviceMedia);
    }

    window.addEventListener('resize', updateDeviceMedia);

    hero.querySelectorAll('video').forEach((video) => {
      video.addEventListener('loadeddata', () => {
        hero.classList.add('video-ready');
      });
      video.addEventListener('error', () => {
        hero.classList.add('video-error');
      });
    });

    const cta = hero.querySelector('.effortless-hero__cta');
    if (cta) {
      cta.addEventListener('mouseenter', () => hero.classList.add('cta-hover'));
      cta.addEventListener('mouseleave', () => hero.classList.remove('cta-hover'));
      cta.addEventListener('focus', () => hero.classList.add('cta-focus'));
      cta.addEventListener('blur', () => hero.classList.remove('cta-focus'));
    }

    document.documentElement.classList.add('effortless-ready');
  }

  function initAllHeroes() {
    document.querySelectorAll('.effortless-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroes);
  } else {
    initAllHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target?.querySelector?.('.effortless-hero') ||
      (event.target?.matches?.('.effortless-hero') ? event.target : null);
    if (hero) {
      hero.dataset.deviceMediaReady = 'false';
      initHero(hero);
    }
  });
})();
